import { render } from "./Kerjasama.vue?vue&type=template&id=f994ddf8"
import script from "./Kerjasama.vue?vue&type=script&lang=js"
export * from "./Kerjasama.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__